import { SimpleResult } from "../dto";
import { Api, getCompanyId, Log } from "../helpers";
import { RydeUiUnit } from "../models";
import { TEntityRelationsMap } from "../models/entity-relations.models";

export class EntityRelationsApi {
  static async getRelations(
    entity: RydeUiUnit,
    id: number,
  ): Promise<TEntityRelationsMap | undefined> {
    const companyId = getCompanyId();
    const response = await Api.get<SimpleResult<TEntityRelationsMap>>(
      `/api/v1/core/c/${companyId}/entity-relations/${entity}/${id}`,
    );

    const result = response?.data;

    if (!result?.success) {
      Log.error("Failed to fetch entity relations", result?.error);
      return undefined;
    }

    return result.data;
  }
}
